module.exports = __webpack_public_path__ + "static/media/abnt.835694f3.png";